"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_react_1 = require("mobx-react");
var React = require("react");
var styles = require('./MessageAdListItem.scss');
var classNames = require('classnames/bind').bind(styles);
var ThreeLineViewPreviewLine = /** @class */ (function (_super) {
    tslib_1.__extends(ThreeLineViewPreviewLine, _super);
    function ThreeLineViewPreviewLine() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ThreeLineViewPreviewLine.prototype.render = function () {
        // We need to give this div a pre-defined height as FAN ad does not have the sender text at the first loading
        // Without the predefined height, we will see a blank UI re-flow
        var previewTextDivClass = classNames(styles.previewDisplayThreeColumn, 'fbAdBody', 'fbAdLink', this.props.previewTexts ? null : styles.messageLineHeightReadingPaneOn);
        return React.createElement("div", { className: previewTextDivClass }, this.props.previewTexts);
    };
    ThreeLineViewPreviewLine = tslib_1.__decorate([
        mobx_react_1.observer
    ], ThreeLineViewPreviewLine);
    return ThreeLineViewPreviewLine;
}(React.Component));
exports.default = ThreeLineViewPreviewLine;
//# sourceMappingURL=ThreeLineViewPreviewLine.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/view/owa-mail-messagead-list-view/lib/components/ThreeLineViewPreviewLine.js
// module id = 6005
// module chunks = 67